import { ACCESS_LINK_PATH } from '@schemas'

let heldToken: string | null = null

/**
 * Moves a setup or reset token from the address into memory. It must run before Sentry starts
 * (see main.tsx): the SDK records the URL a history change leaves behind, fragment included, so
 * removing the token any later would hand it to browser telemetry.
 */
export function holdAccessLinkToken(
  location: Location = window.location,
  history = window.history
) {
  if (location.pathname !== ACCESS_LINK_PATH || !location.hash) return
  heldToken = new URLSearchParams(location.hash.slice(1)).get('token')
  history.replaceState(history.state, '', location.pathname + location.search)
}

/** The token this page load's address carried, if it opened a link. */
export function heldAccessLinkToken() {
  return heldToken
}

export function forgetAccessLinkToken() {
  heldToken = null
}

holdAccessLinkToken()
